module.exports = __webpack_public_path__ + "img/matBook.ef9adbe5.svg";